import { Notification as Data } from '@/typings/api/Notification'
import { Model, createMessages } from '@/helpers/Model'


export class NotificationModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    index: 'Уведомления',
  });
}
